import React, { useState, useEffect } from "react";
import { _mlLicensingUserGroupPermission } from "redux/Types";
import { getCFEpisodes } from "../../../../redux/actions/MlLicFormContentActions";
import { _PermittedContent } from "_module/utils/PermittedContent";
import store from "redux/Store";

export default function CfHqDelivery({
  cf,
  field,
  countOnly = false,
  onChangeLoading,
}) {
  const { clearanceRuntime: { runtime } } = store.getState();

  const [cfEpisodeCount, setCfEpisodeCount] = useState(0);
  const [cfminutes, setCfminutes] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (isLoading && field && cf && cf.programmeType !== runtime?._config?.PROGRAMME_TYPES.ONEOFF) {
      onChangeLoading(isLoading);
      async function fetchCfEpisodesCount() {
        let resutls = await getCFEpisodes(cf.id);
        if(resutls){
          setCfEpisodeCount(resutls);
        }
        setIsLoading(false);
        onChangeLoading(false);
      }
      fetchCfEpisodesCount();
    }else{
      setCfEpisodeCount(1);
      setIsLoading(false);
    }

    if(cf && cf[field.id]){
      let val = cf[field.id] / 60 ; 
      setCfminutes(val);
    }

  }, [cf.id]);

  return (
    <>
      <div key={`${field.id}Wrapper`} >
        {
          isLoading
            ? <span key={`${field.id}loading`} className="loadingText">Loading...</span>
            : <>{cfEpisodeCount} {!countOnly && <> x {cfminutes ? cfminutes : '-'}</>} </>
        }
      </div>
    </>
  );
}
